import { RESET_STORE } from './rootConstants';

export const resetStore = { type: RESET_STORE };
